export default "__VITE_ASSET__CHc8hSmz__";